import { render } from "./OrganizationHeaders.vue?vue&type=template&id=ad46f676&scoped=true"
import script from "./OrganizationHeaders.vue?vue&type=script&lang=js"
export * from "./OrganizationHeaders.vue?vue&type=script&lang=js"

import "./OrganizationHeaders.vue?vue&type=style&index=0&id=ad46f676&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad46f676"]])

export default __exports__